"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiAlert = getMuiAlert;
function getMuiAlert() {
  return {
    styleOverrides: {
      root: function () {
        return {
          '.MuiAlert-action': {
            padding: 0
          },
          '.MuiSvgIcon-root': {
            fontSize: 20,
            height: 20,
            width: 20
          },
          border: 'solid',
          borderRadius: 12,
          borderWidth: 1,
          fontSize: 14,
          fontWeight: 400
        };
      }
    },
    variants: [{
      props: {
        severity: 'success'
      },
      style: function (_ref) {
        var theme = _ref.theme;
        return {
          backgroundColor: theme.palette.success[25],
          borderColor: theme.palette.success[300],
          color: theme.palette.success[700]
        };
      }
    }, {
      props: {
        severity: 'info'
      },
      style: function (_ref2) {
        var theme = _ref2.theme;
        return {
          backgroundColor: theme.palette.primary[25],
          borderColor: theme.palette.primary[300],
          color: theme.palette.primary[700]
        };
      }
    }, {
      props: {
        severity: 'warning'
      },
      style: function (_ref3) {
        var theme = _ref3.theme;
        return {
          backgroundColor: theme.palette.warning[25],
          borderColor: theme.palette.warning[300],
          color: theme.palette.warning[700]
        };
      }
    }, {
      props: {
        severity: 'error'
      },
      style: function (_ref4) {
        var theme = _ref4.theme;
        return {
          backgroundColor: theme.palette.error[25],
          borderColor: theme.palette.error[300],
          color: theme.palette.error[700]
        };
      }
    }, {
      props: {
        color: 'info'
      },
      style: function (_ref5) {
        var theme = _ref5.theme;
        return {
          backgroundColor: "".concat(theme.palette.common.white, " !important"),
          borderColor: "".concat(theme.palette.gray[300], " !important"),
          color: "".concat(theme.palette.gray[700], " !important")
        };
      }
    }, {
      props: {
        color: 'warning'
      },
      style: function (_ref6) {
        var theme = _ref6.theme;
        return {
          backgroundColor: "".concat(theme.palette.gray[25], " !important"),
          borderColor: "".concat(theme.palette.gray[300], " !important"),
          color: "".concat(theme.palette.gray[700], " !important")
        };
      }
    }, {
      props: {
        severity: 'success'
      },
      style: function (_ref7) {
        var theme = _ref7.theme;
        return {
          backgroundColor: theme.palette.success[25],
          borderColor: theme.palette.success[300],
          color: theme.palette.success[700],
          display: 'flex'
        };
      }
    }, {
      props: {
        variant: 'outlined'
      },
      style: {
        border: 'none',
        borderBottom: 'solid',
        borderRadius: 0,
        borderWidth: 1
      }
    }]
  };
}